// 内蒙【蒙东“云招采”全流程电子采购平台】
export default {
    nav: [
        {
            title: '首页',
            href: '/',
            activeReg: /(^\/search*)|(^\/$)/,
        },
        // {
        //     title: '新闻公告',
        //     href: '/news',
        //     activeReg: /(^\/news*)/,
        // },
        {
            title: '交易信息',
            href: '/business',
            activeReg: /(^\/business*)/,
        },
        {
            title: '商城',
            href: 'http://dzsc.mdyzc.cn/login',
            activeReg: /(^\/shop*)/,
            click:`window.open('http://dzsc.mdyzc.cn/login')`
        },
        {
            title: '下载中心',
            href: '/download',
            activeReg: /(^\/download*)/,
            
        },
        {
            title: 'CA办理',
            href: '/cahandle',
            activeReg: /(^\/cahandle*)/,
            click:`window.open('/cahandle')`
        },
        {
            title: '代理抽取',
            href: '/info/list',
            activeReg: /(^\/info*)/,
        },
        {
            title: '专家抽取',
            href: 'http://27.128.162.40:8088/otc/#/login?plan=nm',
            activeReg: /(^\/yuyue*)/,
            click:`window.open('http://27.128.162.40:8088/otc/#/login?plan=nm')`
        },
        {
            title: '关于我们',
            href: '/about',
            activeReg: /(^\/about*)/,
        },
    ],
    head: {
        title: '蒙东“云招采”全流程电子服务平台',//全称
        title2: '蒙东“云招采”全流程电子服务平台',//简称
        jc_title: '蒙东云',//简称
        citycode:'150000',//城市编号
        planName:'nm',
        caType:'nmcaapply',
        meta: {
            description: '内蒙电子采购交易平台,交易平台,招投标,电子交易平台',
            keywords: '内蒙电子采购交易平台,交易平台,招投标,电子交易平台',
        },
        favicon: '/nm/favicon.ico',
        logoUrl: '/nm/images/logo.png',//首页LOGO
        loginImgUrl: '',
        registerImg: '',//注册页面LOGO
        bannerList:[
            {
                linkimg:'/nm/images/banner.png',
                linkurl:''
            }
        ],
        tbLoginUrl:'http://27.128.162.40:9001/newtbr/index.html#/login?plan=nm',
        // 用户角色登录
        userRoles: [
            {
                imgsrc: '',
                href: 'http://27.128.162.40:8088/otc/#/login?plan=nm',
                title: '代理机构登录',
                class: 'primary',
            },
            {
                imgsrc: '',
                href: 'http://27.128.162.40:9001/newtbr/index.html#/login?plan=nm',
                title: '投标人/供应商登录',
                class: 'primary',
            },
            {
                imgsrc: '',
                href: 'http://nmpingbiao.zchzb.com?plan=nm',
                title: '专家登录',
                class: 'primary'
            },
            {
                imgsrc: '',
                href: 'http://27.128.162.40:8088/otc/#/login?plan=nm&mRole=tender',
                title: '采购人/招标人登录',
                class: 'primary',
            },
        ],
        userRolesZfcg:[],
        friendLinks:[],
        tel: '0476-5958858', //客服电话
        tel2: '',//备用电话/其他电话
        fax: '',//传真号码
        email: 'yunzhaocai@163.com', //邮箱地址
        workTime: '9:00-21:30',//工作时间
        postalCode: '',//邮政编码
        companyName: '内蒙古蒙东云科技有限公司',  //运营公司名称
        companyAddress: '内蒙古自治区赤峰市 中昊大厦A座4层',//公司地址
        companyLatLng:{ lng: 0, lat: 0 },//公司地址坐标
        showWeather: false,//是否显示天气
        icp:'蒙ICP备2022001009号-1',
        gwIcp:'',
        isCheckOtherSingleCertCode: true, //注册页面 是否校验 其他一证一照代码
        showAd: true,//首页显示广告位
        adList: [{
            image: '/nm/images/anbiao.png',
            text:'清标工具',
            url: 'https://www.huitoue.com/application/bidding-clearing?setting_no_nav=true&channel=10509fd817e34ee793cde54a74fd0c95',
        },{
            image: '/nm/images/tbwjzz.png',
            text:'投标文件制作',
            type: 'tbwjzz'
        },{
            image: '/nm/images/baohan.png',
            text:'保函办理',
            url: 'https://bhtong.cn/?channel=mdyzc#handing-flow'
        },{
            image: '/nm/images/ca.png',
            text:'CA办理',
            url: '/cahandle'
        }],
        bzList: [
            {
                image: '/nm/images/aibz.png',
                text:'AI编制',
                url: 'https://biaoshu.huitoue.com/?source=mdyzc&inviteCode=185626&channelCode=668333#/web'
            },
            {
                image: '/nm/images/rgbz.png',
                text:'人工编制',
                url: 'https://www.huitoue.com/application/file-agent?setting_no_nav=true&channel=10509fd817e34ee793cde54a74fd0c95'
            }
        ]
    },
    proxy: {
        '/web': {
            target: 'http://www.mdyzc.cn',
            changeOrigin:true,
        },
    },
}